export default __webpack_public_path__ + "static/media/10.c8f49147.jpeg";